var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eeb0b7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.828,24H29.172A5.172,5.172,0,0,0,24,29.172V43.828A5.172,5.172,0,0,0,29.172,49H43.828A5.172,5.172,0,0,0,49,43.828V29.172A5.172,5.172,0,0,0,43.828,24ZM38.96,44.994a.431.431,0,0,1-.3.126H28.31a.431.431,0,0,1-.431-.431V28.31a.431.431,0,0,1,.431-.431H38.655a.431.431,0,0,1,.431.432l0,2.17h-.862l0-1.739H28.741V44.259h9.482l0-1.739h.862l0,2.17A.431.431,0,0,1,38.96,44.994Zm6.034-8.19-4.31,4.31-.61-.61,3.574-3.574H31.328v-.862H43.649l-3.575-3.575.61-.61,4.31,4.31a.431.431,0,0,1,0,.61Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/iconLogout.dc0bff1a80dbee84d519db51c1e78603.svg";
export { ForwardRef as ReactComponent };